<template>
  <filtered-search
    :search-filters="searchFilters"
    :search-route="searchRoute"
    :place-holder="placeHolder"
    :model="model"
  >
    <template
      slot="results"
      slot-scope="{ items }"
    >
      <li
        v-for="(distributor, index) in items"
        :key="distributor.id"
        :class="{
            'border-t border-gray-200': index > 0
        }"
      >
          <a
              :href="distributor.route"
              class="block transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus:bg-gray-50"
          >
              <div class="flex items-center px-4 py-3 sm:py-4 sm:px-6">
                  <div class="flex items-center flex-1 min-w-0">
                      <div class="flex-shrink-0">
                          <img
                              class="w-8 h-8 rounded-full md:h-12 md:w-12"
                              :src="distributor.thumbnail"
                              alt=""
                              loading="lazy"
                          >
                      </div>
                      <div class="flex-1 min-w-0 px-4 md:grid md:grid-cols-2 md:gap-4">
                          <div class="col-span-3 space-y-1">
                              <div class="flex space-x-2 text-sm font-semibold leading-5 text-blue-900 truncate hover:text-blue-700 lg:text-md visited:text-indigo-800">
                                <span v-html="distributor.name_edge_ngram"></span>
                                <span
                                    v-if="distributor.type"
                                    class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium leading-4 tracking-wide"
                                    :class="{
                                        'bg-green-100 text-green-800': distributor.type == 'principal',
                                        'bg-gray-100 text-gray-800': distributor.type != 'principal',
                                    }"
                                  >
                                    <span v-html="distributor.type_edge_ngram"></span>
                                  </span>
                              </div>
                              <div class="flex space-x-2 text-sm sm:text-md">
                                  <div
                                      v-if="distributor.distributorship"
                                      class="flex items-center leading-5 text-gray-500"
                                  >
                                      <span v-html="distributor.distributorship" class="truncate"></span>
                                  </div>
                                  <div
                                      v-if="distributor.city_state_edge_ngram"
                                      class="flex items-center leading-5 text-gray-500 sm:mt-0"
                                  >
                                      <svg
                                          class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                                          viewBox="0 0 20 20"
                                          fill="currentColor"
                                      >
                                          <path
                                              fill-rule="evenodd"
                                              d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                              clip-rule="evenodd"
                                          />
                                      </svg>
                                      <p v-html="distributor.city_state_edge_ngram"></p>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div>
                      <svg
                          class="w-5 h-5 text-gray-400"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                      >
                          <path
                              fill-rule="evenodd"
                              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                              clip-rule="evenodd"
                          />
                      </svg>
                  </div>
              </div>
          </a>
      </li>
    </template>
  </filtered-search>
</template>

<script>
export default {
  props: {
    searchFilters: {
      type: [Array, Object],
      required: true,
    },
    searchRoute: {
      type: String,
      required: true,
    },
    placeHolder: {
        type: String,
        required: false,
        default: 'Search...'
    },
    model: {
        type: [Array, Object],
        required: true,
    }
  },

  data: () => ({}),
};
</script>
